import React, { useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import * as Yup from 'yup';

import { useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Field, Form, Formik } from 'formik';
import { FormServiceContext } from 'app/utils/contexts';

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormHelperText,
    Grid,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import notification from 'app/config/notification';
import { verifyLicencaNameAndFormat } from 'app/utils/forms/services/licenses';
import { SERVICES_CODES } from 'app/config/services';

const DialogCitySelection = (props) => {
    const { open, handleCancel, handleSave, selectedCity, cities } = props;

    const validationSchema = Yup.object().shape({
        cdMunicipio: Yup.string().required('Campo obrigatório'),
    });

    const onCancel = (e, reason) => {
        if (reason && reason === 'backdropClick') return;
        if (handleCancel) handleCancel(e);
    };

    return (
        <Dialog disableEscapeKeyDown open={open} onClose={onCancel}>
            <DialogTitle>Selecione o município</DialogTitle>
            <Formik
                enableReinitialize={true}
                initialValues={{ cdMunicipio: '' }}
                validationSchema={validationSchema}
                validateOnBlur={false}
                validateOnChange={false}
                onSubmit={() => {}}>
                {(formProps) => {
                    const { errors } = formProps;
                    return (
                        <Form>
                            <DialogContent style={{ paddingTop: '0px', maxWidth: '350px' }}>
                                <FormControl
                                    variant="filled"
                                    margin="dense"
                                    fullWidth
                                    error={!!errors.cdMunicipio}
                                    style={{ minWidth: '300px' }}>
                                    <Field name="cdMunicipio" id="cdMunicipio" native as={Select}>
                                        <option aria-label="None" value="">
                                            Selecione
                                        </option>
                                        {cities.map((c, index) => {
                                            return (
                                                <option key={`type-${index}`} value={c.cdMunicipio}>
                                                    {c.nmMunicipio}
                                                </option>
                                            );
                                        })}
                                    </Field>
                                    {errors.cdMunicipio ? <FormHelperText>{errors.cdMunicipio}</FormHelperText> : null}
                                </FormControl>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => handleCancel()} color="primary">
                                    Cancelar
                                </Button>
                                <Button
                                    onClick={() => {
                                        formProps.validateForm().then((res) => {
                                            if (Object.keys(res).length <= 0) {
                                                handleSave(formProps.values, selectedCity);
                                            }
                                        });
                                    }}
                                    color="primary">
                                    Salvar
                                </Button>
                            </DialogActions>
                        </Form>
                    );
                }}
            </Formik>
        </Dialog>
    );
};

function Itinerary(props) {
    const { classes, data, setData, intl, oldItinerary } = props;
    const { canEdit, errorsList, setErrorsList } = useContext(FormServiceContext);
    const [open, setOpen] = React.useState(false);
    const [selectedCity, setSelectCity] = useState(null);

    const cities = useSelector((state) => state.forms.cities);
    const request = useSelector((state) => state.requests.details);

    const [filteredCollectionData, setFilteredCollectionData] = useState({
        dataBoExcluido: [],
        dataBoNotExcluido: [],
    });

    const changeElement = async (index) => {
        let temp = [...data];
        if (index === undefined) {
            handleClickOpen(temp.length);
        } else {
            if (window.confirm('Deseja excluir este item?')) {
                temp = verifyLicencaNameAndFormat({
                    filteredCollectionData,
                    index,
                    cdLicencaName: 'cdLicencaItinerario',
                });
            }
        }
        setData(temp);
    };

    const handleClickOpen = (index) => {
        setSelectCity(index);
        setOpen(true);
    };

    const handleCancel = () => {
        setSelectCity(null);
        setOpen(false);
    };

    useEffect(() => {
        const init = () => {
            const temp = _.cloneDeep(data);
            const dataBoExcluido = temp.filter((c) => c.boExcluido);
            const dataBoNotExcluido = temp
                .filter((c) => !c.boExcluido)
                .map((c) => {
                    const t = { ...c };
                    const found = _.find(cities, ['cdMunicipio', Number(c.cdMunicipio)]);
                    t.nmMunicipio = found?.nmMunicipio;
                    return t;
                });
            setFilteredCollectionData({
                dataBoExcluido,
                dataBoNotExcluido,
            });
        };
        init();
    }, [cities, data]);

    const onChangeField = async (city, index) => {
        if (request.cdServico === SERVICES_CODES.LICENCA_SEGUNDA_VIA) {
            if (oldItinerary.length === data.length) {
                notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.NOT_ADD_ELEMENTS_MORE_THAN_ORIGIAL' }), {
                    toastId: 'NOT_ADD_ELEMENTS_MORE_THAN_ORIGIAL',
                    type: 'warning',
                });
                return;
            }
        }

        let temp = _.cloneDeep(data);

        const { dataBoExcluido, dataBoNotExcluido } = filteredCollectionData;
        const indexLastCity = dataBoNotExcluido.length - 1;
        const cdSelectedCity = Number(city.cdMunicipio);
        const cdFirstCity = dataBoNotExcluido[0]?.cdMunicipio;
        const cdLastCity = dataBoNotExcluido[indexLastCity]?.cdMunicipio;

        const found = _.find(cities, ['cdMunicipio', cdSelectedCity]);
        const foundOnList = _.filter(dataBoNotExcluido, (tempCity) => cdSelectedCity === tempCity.cdMunicipio);

        if (found) {
            if (dataBoNotExcluido.length < 2) {
                if (foundOnList.length) {
                    notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.ELEMENT_ALREADY_EXISTS' }), {
                        toastId: 'ELEMENT_ALREADY_EXISTS',
                        type: 'warning',
                    });
                    return;
                }
            } else {
                if (foundOnList.length) {
                    if (foundOnList.length >= 2 && cdSelectedCity === cdFirstCity) {
                        notification(
                            intl.formatMessage({
                                id: 'MESSAGES.SERVICE.FORMS.FIRST_ELEMENT_ALREADY_EXISTS_TWO_TIMES',
                            }),
                            {
                                toastId: 'FIRST_ELEMENT_ALREADY_EXISTS_TWO_TIMES',
                                type: 'warning',
                            },
                        );
                        return;
                    }

                    if (cdSelectedCity !== cdFirstCity) {
                        notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.ELEMENT_ALREADY_EXISTS' }), {
                            toastId: 'ELEMENT_ALREADY_EXISTS',
                            type: 'warning',
                        });
                        return;
                    }
                } else {
                    if (cdFirstCity && cdLastCity && cdFirstCity === cdLastCity) {
                        notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.REMOVE_LAST_ELEMENT_TO_ADD' }), {
                            toastId: 'REMOVE_LAST_ELEMENT_TO_ADD',
                            type: 'warning',
                        });
                        return;
                    }
                }
            }

            dataBoNotExcluido[indexLastCity + 1] = {
                cdMunicipio: found.cdMunicipio,
                nmMunicipio: found.nmMunicipio,
            };
        }

        if (errorsList && errorsList.itinerary) {
            const errorsTemp = { ...errorsList };
            delete errorsTemp.itinerary;
            setErrorsList(errorsTemp);
        }

        temp = [...dataBoNotExcluido, ...dataBoExcluido].map((city, index) => ({
            ...city,
            nuOrdem: index + 1,
        }));
        setData(temp);
        handleCancel();
    };

    return (
        <>
            <DialogCitySelection
                {...props}
                selectedCity={selectedCity}
                open={open}
                handleCancel={handleCancel}
                handleSave={onChangeField}
                classes={classes}
                cities={cities}
            />

            <Grid item xs={12}>
                <h3 className={classes.titleTable}>Itinerário</h3>
                <Table className={errorsList?.itinerary ? classes.tableError : classes.table}>
                    <TableHead>
                        <TableRow className={classes.tableRow}>
                            <TableCell className={classes.headTableCell} align="left">
                                ID
                            </TableCell>
                            <TableCell className={classes.headTableCell} align="left">
                                Município
                            </TableCell>
                            {canEdit && (
                                <TableCell className={classes.headTableCell} align="center">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disableElevation
                                        onClick={() => changeElement()}
                                        className={classes.addButton}>
                                        <AddIcon /> Adicionar
                                    </Button>
                                </TableCell>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredCollectionData.dataBoNotExcluido.map((row, indexRow) => (
                            <TableRow key={`irr-row-${indexRow}`} className={classes.tableRow}>
                                <TableCell align="left">{row.cdMunicipio || ''}</TableCell>
                                <TableCell align="left">{row.nmMunicipio || ''}</TableCell>
                                {canEdit && (
                                    <TableCell align="right">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => changeElement(indexRow)}
                                            className={classes.btnSigleAction}
                                            size="small">
                                            <DeleteIcon fontSize="inherit" />
                                        </Button>
                                    </TableCell>
                                )}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Grid>
        </>
    );
}

export default injectIntl(Itinerary);
